import React from "react";
import { DefaultContextValue } from "@hex-insights/core";
import { FormState, FormType } from "@hex-insights/forms";
import { usePermissionCheck } from "@hex-insights/permissioning";
import { permissions } from "../../../../Utilities";
import { SharingPolicyCustomFormValues, SharingPolicyFormValues } from "../../../FormUtilities";

export type SharingMenuFormValues = Omit<SharingPolicyFormValues.Base, SharingPolicyCustomFormValues.ParentFields>;

export function useSetIsPublic(formState: FormState<SharingMenuFormValues>) {
	const { userGroupIDs, userIDs } = formState.formValues;
	const { isPublic: setIsPublic } = formState.formSetFunctions;

	React.useEffect(() => {
		if (userGroupIDs.length > 0 || userIDs.length > 0) {
			setIsPublic(false);
		}
	}, [userGroupIDs, userIDs, setIsPublic]);
}

export type SharingMenuContextValue = {
	hasAdminPermission: boolean;
};

export const SharingMenuContext = React.createContext<SharingMenuContextValue>(
	new DefaultContextValue("SharingMenuContext") as any,
);

export function useHasAdminSharingPermission(formType: FormType) {
	return usePermissionCheck({ requiredPermission: getAdminSharingPermission(formType) });
}

function getAdminSharingPermission(formType: FormType) {
	switch (formType) {
		case FormType.Create:
			return permissions.SharingPolicy.Create.Admin;
		case FormType.Update:
			return permissions.SharingPolicy.Update.Admin;
		default:
			return permissions.SharingPolicy.View.Basic;
	}
}
